import React from 'react';
import './Features.css';
import { useSectionView } from '../hooks/useSectionView';
import { sendEvent } from '../analytics';

const Features = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const ScrollArrow = ({ targetSection, className }) => (
    <div 
      className={`scroll-arrow ${className || ''}`}
      onClick={() => { try { sendEvent('scroll_arrow_click', { target_section: (targetSection || '').replace('-section','') }); } catch (_) {} scrollToSection(targetSection); }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M7 10L12 15L17 10" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );

  return (
    <div id="features-section" className="features-section">
      {useSectionView('features', 'features-section')}
      <div className="features-container">
        <div className="features-title">
          Ruimte voor groei, expertise voor succes
        </div>
        <div className="features-content">
          <div className="features-left">
            <div className="features-divider">
              <div className="divider-line-gray"></div>
              <div className="divider-line-purple"></div>
            </div>
            <div className="features-list">
              <div className="feature-item">
                <div className="feature-number-container">
                  <div className="feature-number">01</div>
                </div>
                <div className="feature-content">
                  <div className="feature-icon">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 32V8h24v24H8z" stroke="#18191C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 12h16M12 16h12M12 20h8" stroke="#18191C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M28 28l4-4-4-4" stroke="#18191C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="feature-title">Planologie</div>
                  <div className="feature-description">
                    Strategische ruimtelijke planning en beleidsontwikkeling voor duurzame gebiedsontwikkeling. Van visievorming tot anterieure overeenkomst.
                  </div>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-number-container">
                  <div className="feature-number">02</div>
                </div>
                <div className="feature-content">
                  <div className="feature-icon">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 34h28M20 6v28" stroke="#18191C" strokeWidth="2" strokeLinecap="round"/>
                      <path d="M12 18l8-8 8 8M12 26h16" stroke="#18191C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="10" cy="30" r="2" stroke="#18191C" strokeWidth="2"/>
                      <circle cx="30" cy="30" r="2" stroke="#18191C" strokeWidth="2"/>
                    </svg>
                  </div>
                  <div className="feature-title">Gebiedseconomie</div>
                  <div className="feature-description">
                    Economische haalbaarheidsanalyses en marktonderzoek voor gebiedsontwikkeling. Financiële modellering en investeringsanalyses voor optimale rendabiliteit.
                  </div>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-number-container">
                  <div className="feature-number">03</div>
                </div>
                <div className="feature-content">
                  <div className="feature-icon">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 10h28v20H6V10z" stroke="#18191C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M10 18h6M10 22h4M22 18h8M22 22h6" stroke="#18191C" strokeWidth="2" strokeLinecap="round"/>
                      <path d="M18 14v12M18 14l-2 2M18 14l2 2" stroke="#18191C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="10" cy="6" r="2" stroke="#18191C" strokeWidth="2"/>
                      <circle cx="20" cy="6" r="2" stroke="#18191C" strokeWidth="2"/>
                      <circle cx="30" cy="6" r="2" stroke="#18191C" strokeWidth="2"/>
                    </svg>
                  </div>
                  <div className="feature-title">Projectmanagement</div>
                  <div className="feature-description">
                    Integrale projectbegeleiding van concept tot realisatie. Projectmanagement, stakeholder management en procesoptimalisatie voor succesvolle gebiedsontwikkeling.
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="features-right">
            <div className="dashboard-container">
              <div className="dashboard-mask">
                <div className="dashboard-background"></div>
                <div className="dashboard-blur">
                  <svg width="506" height="321" viewBox="0 0 506 321" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_f_2_150)">
                      <path d="M279 264.848C279 279.981 273.851 294.859 264.05 308.05C254.248 321.242 240.123 332.301 223.036 340.165C205.948 348.028 186.473 352.431 166.485 352.948C146.497 353.466 126.67 350.081 108.911 343.12C91.1531 336.159 76.0623 325.856 65.0917 313.203C54.121 300.55 47.64 285.973 46.2726 270.875C44.9052 255.777 48.6975 240.667 57.2843 227" stroke="url(#paint0_linear_2_150)" strokeOpacity="0.4" strokeWidth="200" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                      <filter id="filter0_f_2_150" x="-180.402" y="0.586845" width="685.802" height="578.813" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                        <feGaussianBlur stdDeviation="63.2" result="effect1_foregroundBlur_2_150"/>
                      </filter>
                      <linearGradient id="paint0_linear_2_150" x1="70.5633" y1="221.852" x2="262.311" y2="347.929" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FF7557"/>
                        <stop offset="0.5" stopColor="#173EFF"/>
                        <stop offset="1" stopColor="#16F1FF"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
              
              <div className="dashboard-content">
                <div className="dashboard-top-card"></div>
                <div className="dashboard-main-card"></div>
                <div className="dashboard-placeholder">
                  <div className="project-image">
                    <img 
                      src="https://di262mgurvkjm.cloudfront.net/d52e426e-7b36-49a4-9685-f1c971a71f8c/amersfoort-eemkwartier-luchtfoto-303555_xgaplus.jpg" 
                      alt="Luchtfoto van het Eemkwartier in Amersfoort - binnenstedelijke gebiedsontwikkeling" 
                      className="project-photo"
                    />
                  </div>
                  <div className="placeholder-text-content">
                    <p className="placeholder-text">
                    Het project is een herontwikkeling van dit voormalige NS-terrein nabij station Amersfoort tot een gemengd woongebied met circa 900 woningen. Financiële advisering bij gesprekken met marktpartijen over kostenverhaal namens de gemeente.
                    </p>
                  </div>
                </div>
                
                <div className="dashboard-header">
                  <div className="case-study-title">
                    Kostenverhaal binnenstedelijke transformatie
                  </div>
                  <div className="case-study-meta">
                    <div className="collaborators-avatars">
                      <svg width="92" height="36" viewBox="0 0 92 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="18" cy="18" r="17" fill="#ECECF1" stroke="white" strokeWidth="2"/>
                        <circle cx="46" cy="18" r="17" fill="#ECECF1" stroke="white" strokeWidth="2"/>
                        <circle cx="74" cy="18" r="17" fill="#ECECF1" stroke="white" strokeWidth="2"/>
                      </svg>
                    </div>
                    <div className="meta-text">2 Medewerkers</div>
                    <div className="meta-text">Aangemaakt 4 weken geleden</div>
                  </div>
                </div>
                
                <div className="dashboard-stats">
                  <div className="stat-card">
                    <div className="stat-header">
                      <div className="stat-title">Project inzet</div>
                    </div>
                    <div className="stat-content">
                      <div className="stat-number">12 maanden</div>
                      <div className="stat-icon-container">
                        <div className="stat-icon-bg blue-bg"></div>
                        <svg className="stat-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="10" cy="10" r="8" stroke="#1F2026" strokeWidth="2"/>
                          <path d="M10 6v4l3 3" stroke="#1F2026" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  
                  <div className="stat-card">
                    <div className="stat-header">
                      <div className="stat-title">Woningen</div>
                    </div>
                    <div className="stat-content">
                      <div className="stat-number">900</div>
                      <div className="stat-icon-container">
                        <div className="stat-icon-bg green-bg"></div>
                        <svg className="stat-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 9l9-7 9 7v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="#1F2026" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <polyline points="9,22 9,12 15,12 15,22" stroke="#1F2026" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  
                  <div className="stat-card">
                    <div className="stat-header">
                      <div className="stat-title">Locatie</div>
                    </div>
                    <div className="stat-content">
                      <div className="stat-number">Amersfoort</div>
                      <div className="stat-icon-container">
                        <div className="stat-icon-bg orange-bg"></div>
                        <svg className="stat-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 12l2 2 4-4" stroke="#1F2026" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="10" cy="10" r="8" stroke="#1F2026" strokeWidth="2"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrollArrow targetSection="team-section" className="features-arrow" />
    </div>
  );
};

export default Features;
